import BirdLifeBLIcon from '../svg/BirdLifeBL.svg';

export default BirdLifeBLIcon;
